import { useEffect, useMemo, useState } from "react"
import { VerticalType } from "src/libs/scalars/interface/IScalarForm"
import Scalar from "src/libs/scalars/scalars/Scalar"
import { ITypography } from "../../data/interfaces"
import { schema } from "../../data/schema"
import { ICompositeWidgetProps } from "../LandingCompositeWidget"
import { CompositeForm } from "./CompositeForm"

/* Protopia Ecosystem component */ 
const TypographyScalar = (props: ICompositeWidgetProps): JSX.Element => {
    return <>
            <Scalar  
                value={ props.value }
                editable={props.editable }
                notClear
                rowClassName="width-auto"
                vertical={ VerticalType.VERTICAL }
                enabledForm={ <TypographyScalarEnabled {...props} /> }  
                desabledForm={ <TypographyScalarDisable {...props} /> }   
                subMenus={props.subMenus}
                onSubMenu={props.onSubmenu}
            />
        </>
}
export default TypographyScalar

const TypographyScalarEnabled = ( props: ICompositeWidgetProps ): JSX.Element => {
    const [value, setValue] = useState<ITypography>( props.value || props.default )
    const typoSchema = useMemo(() => schema().Typography, [])
    useEffect(() => {
        setValue( props.value || props.default )
    }, [props.value, props.default])
    
    const onChange = ( _value: any, field: string, data: any ) => {
        const newValue = {
            ...( props.value || props.default ),
            [field]: _value
        }
        // console.log( newValue )
        if(props.onChange) {
            props.onChange( newValue, props.field, "" )
        }
        else {
            setValue( newValue )
        } 
    }
    return <CompositeForm 
        schemaType={ typoSchema.apollo_fields } 
        origin={ props.origin }
        value={ value }
        onChange={ onChange }
        schemaData={ typoSchema} 
        onCollapsesOpen={ ( i: number ) => {} }
        isCollapsesOpen={ [ true ] }
        sectionId={ props.sectionId }
        notClear={false}
        formClassname=" pos "
    /> 
}

const TypographyScalarDisable = (props: ICompositeWidgetProps): JSX.Element => {
    return <>{JSON.stringify(props.value)}</>
}